import React from "react";

import { updateRecommandationSurvey } from "EntitiesApi/api";
import isIntuit from "Intuit/isIntuit";
import get from "lodash/get";
import { setFilter, updateRecommendedPlans } from "QuotePage/Actions";
import { getRecommendationSurvey } from "QuotePage/Selectors";
import { connect } from "react-redux";
import { reduxForm, submit, formValueSelector } from "redux-form";
import { validateRequired, validateNumber } from "Utils/Validations";

import BodyText from "Common/BodyText";
import { SIFormField, SIFormRadioGroup, SIFormTinyInput, SIFormCheckbox } from "Common/forms";
import AppearingForm, { AppearingFormSection } from "Common/forms/AppearingForm";
import { numberMaskWithoutCommas } from "Common/forms/masks";
import { Row } from "Common/Grid";

import {
  getShoppingReasonCopy,
  getDoctorImportanceCopy,
  getDeductibleImportanceCopy,
  getEmployeeDemographicCopy,
  getOtherCopy,
} from "./RecommendationSurveyUtils";

import makeBem from "Utils/makeBem";

const bem = makeBem("RecommendationSurveyForm");

const getSpacing = () => (isIntuit() ? 3 : 4);

class Page1Dumb extends React.Component {
  componentDidMount() {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged) {
      onCompleteChanged(this.props.isComplete, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged && this.props.isComplete !== prevProps.isComplete) {
      onCompleteChanged(this.props.isComplete, prevProps.isComplete);
    }
  }

  render() {
    const shoppingReasonCopy = getShoppingReasonCopy();

    return (
      <div className={bem("ModalPage")}>
        <BodyText>{shoppingReasonCopy.question}</BodyText>
        <Row pt={getSpacing()}>
          <SIFormField
            name="recommendationSurvey.shoppingReason"
            validate={validateRequired}
            component={SIFormRadioGroup}
            props={{
              options: shoppingReasonCopy.options,
            }}
          />
        </Row>
      </div>
    );
  }
}

const getRecommendationSurveyFormValues = formValueSelector("recommendationSurvey");

const Page1 = connect((state) => ({
  isComplete: getRecommendationSurveyFormValues(state, "recommendationSurvey.shoppingReason"),
}))(Page1Dumb);

class Page2Dumb extends React.Component {
  componentDidMount() {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged) {
      onCompleteChanged(this.props.isComplete, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged && this.props.isComplete !== prevProps.isComplete) {
      onCompleteChanged(this.props.isComplete, prevProps.isComplete);
    }
  }

  render() {
    const doctorImportanceCopy = getDoctorImportanceCopy();
    return (
      <div className={bem("ModalPage")}>
        <BodyText>{doctorImportanceCopy.question}</BodyText>
        <Row pt={getSpacing()}>
          <SIFormField
            name="recommendationSurvey.doctorImportance"
            validate={validateRequired}
            component={SIFormRadioGroup}
            props={{
              options: doctorImportanceCopy.options,
            }}
          />
        </Row>
      </div>
    );
  }
}

const Page2 = connect((state) => ({
  isComplete: getRecommendationSurveyFormValues(state, "recommendationSurvey.doctorImportance"),
}))(Page2Dumb);

class Page3Dumb extends React.Component {
  componentDidMount() {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged) {
      onCompleteChanged(this.props.isComplete, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged && this.props.isComplete !== prevProps.isComplete) {
      onCompleteChanged(this.props.isComplete, prevProps.isComplete);
    }
  }

  render() {
    return (
      <div className={bem("ModalPage")}>
        <BodyText>What is your preferred deductible level?</BodyText>
        <Row pt={getSpacing()}>
          <SIFormField
            name="recommendationSurvey.deductibleImportance"
            validate={validateRequired}
            component={SIFormRadioGroup}
            props={{
              options: getDeductibleImportanceCopy(),
            }}
          />
        </Row>
      </div>
    );
  }
}

const Page3 = connect((state) => ({
  isComplete: getRecommendationSurveyFormValues(state, "recommendationSurvey.deductibleImportance"),
}))(Page3Dumb);

class Page4Dumb extends React.Component {
  componentDidMount() {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged) {
      onCompleteChanged(this.props.isComplete, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { onCompleteChanged } = this.props;

    if (onCompleteChanged && this.props.isComplete !== prevProps.isComplete) {
      onCompleteChanged(this.props.isComplete, prevProps.isComplete);
    }
  }

  render() {
    const employeeDemographicOptions = getEmployeeDemographicCopy();

    return (
      <div className={bem("ModalPage")}>
        <BodyText>How many employees do you have in each of these groups?</BodyText>
        <Row pt={getSpacing()}>
          {Object.entries(employeeDemographicOptions).map(([fieldName, label]) => (
            <SIFormField
              name={`recommendationSurvey.${fieldName}`}
              props={{
                label,
                size: 2,
                maxLength: 2,
                mask: numberMaskWithoutCommas,
              }}
              validate={[validateRequired, validateNumber]}
              component={SIFormTinyInput}
              mb={0}
              key={fieldName}
            />
          ))}
        </Row>
      </div>
    );
  }
}

const Page4 = connect((state) => ({
  isComplete:
    state.form.recommendationSurvey.values.recommendationSurvey.numYoung > 0 ||
    state.form.recommendationSurvey.values.recommendationSurvey.numOld > 0 ||
    state.form.recommendationSurvey.values.recommendationSurvey.numChildren > 0 ||
    state.form.recommendationSurvey.values.recommendationSurvey.numNotSure > 0,
}))(Page4Dumb);

class Page5 extends React.Component {
  componentDidMount() {
    const { onCompleteChanged } = this.props;

    onCompleteChanged(true, false);
  }

  render() {
    const otherOptions = getOtherCopy();

    return (
      <div className={bem("ModalPage")}>
        <BodyText>What else is important to you? Check all that apply:</BodyText>
        <Row pt={getSpacing()} style={{ marginLeft: "-16px" }}>
          {Object.entries(otherOptions).map(([fieldName, label]) => (
            <SIFormField name={`recommendationSurvey.${fieldName}`} props={{ label }} component={SIFormCheckbox} mb={3} key={fieldName} />
          ))}
        </Row>
      </div>
    );
  }
}

class RecommendationSurveyForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.currentPage || 0,
    };
  }

  handlePageChanged = (currentPage) => {
    this.setState({
      currentPage,
    });
  };

  render() {
    const { submitSurveyAndUpdateFilter, submitting, isRecommendationSurveyLoaded } = this.props;

    if (!isRecommendationSurveyLoaded) return "Loading...";

    return (
      <AppearingForm onPageChanged={this.handlePageChanged} submit={submitSurveyAndUpdateFilter} submitting={submitting} currentPage={this.state.currentPage}>
        <AppearingFormSection>
          <Page1 />
        </AppearingFormSection>
        <AppearingFormSection>
          <Page2 />
        </AppearingFormSection>
        <AppearingFormSection>
          <Page3 />
        </AppearingFormSection>
        <AppearingFormSection>
          <Page4 />
        </AppearingFormSection>
        <AppearingFormSection>
          <Page5 />
        </AppearingFormSection>
      </AppearingForm>
    );
  }
}

const mapStateToProps = (state) => {
  const recommendationSurvey = getRecommendationSurvey(state);
  const isRecommendationSurveyLoaded = get(state, "recommendationSurvey.isLoaded");

  return {
    companyProfile: state.companyProfile,
    recommendationSurvey,
    isRecommendationSurveyLoaded,
    initialValues: {
      recommendationSurvey: recommendationSurvey || {
        numYoung: 0,
        numOld: 0,
        numChildren: 0,
        numNotSure: 0,
      },
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitSurveyAndUpdateFilter: () => {
    dispatch(submit("recommendationSurvey"));
  },
  handlePageChange: () => {
    dispatch(setFilter("recommendation_mode", "recommended"));
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withReduxForm = reduxForm({
  form: "recommendationSurvey",
  destroyOnUnmount: false,
  onSubmit: (values, dispatch, props) =>
    new Promise((onSuccess, onFailure) => {
      props.handlePageChange();
      dispatch(
        updateRecommandationSurvey(props.companyProfile.id, values.recommendationSurvey, {
          onSuccess,
          onFailure,
        }),
      );
    }),
  onSubmitSuccess: (values, dispatch, props) => {
    if (props.onSubmitModalCallback) {
      props.onSubmitModalCallback.onHide("consultationModal");
    }
    dispatch(updateRecommendedPlans(values.recommendedPlans));
    if (props.onSubmitComplete) props.onSubmitComplete();
  },
  enableReinitialize: true,
});

export default withRedux(withReduxForm(RecommendationSurveyForm));
